/* CARI storefront behaviour: buy box, sticky ATC, cart drawer, exit intent. No dependencies. */
(() => {
  const CARI = (window.CARI = window.CARI || {});
  const root = (CARI.routes && CARI.routes.root) || '/';
  const url = (path) => root.replace(/\/$/, '') + path;
  const $ = (sel, el = document) => el.querySelector(sel);
  const $$ = (sel, el = document) => Array.from(el.querySelectorAll(sel));
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const readJSON = (el) => { try { return JSON.parse(el.textContent); } catch (e) { return null; } };
  const store = {
    get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { localStorage.setItem(k, v); } catch (e) {} },
  };

  // Money formatting from shop.money_format
  CARI.money = (cents) => {
    const fmt = CARI.moneyFormat || '${{amount}}';
    const n = (Number(cents) || 0) / 100;
    const group = (x, sep, dec, places) => {
      const [i, d] = x.toFixed(places).split('.');
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, sep) + (d ? dec + d : '');
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => ({
      amount: group(n, ',', '.', 2),
      amount_no_decimals: group(n, ',', '.', 0),
      amount_with_comma_separator: group(n, '.', ',', 2),
      amount_no_decimals_with_comma_separator: group(n, '.', ',', 0),
      amount_with_apostrophe_separator: group(n, "'", '.', 2),
    }[k] || group(n, ',', '.', 2)));
  };

  // "Standard:Ground, Whole Bean:Whole bean" -> { Standard: 'Ground', ... }
  const parseLabels = (str) => (str || '').split(',').reduce((acc, pair) => {
    const [k, v] = pair.split(':').map((s) => s && s.trim());
    if (k && v) acc[k] = v;
    return acc;
  }, {});
  const relabel = (text, labels) => String(text || '').split(' / ').map((p) => labels[p] || p).join(' / ');

  const PREVIEW_OFF_CENTS = 1000;

  const isPreviewTheme = () => {
    const t = window.Shopify && window.Shopify.theme;
    return CARI.designMode || (t && t.role && t.role !== 'main');
  };

  /* ---------------- Cart drawer ---------------- */
  const drawer = $('[data-cari-drawer]');
  const cartCfg = readJSON($('[data-cari-cart-config]') || { textContent: '{}' }) || {};
  const cartLabels = parseLabels(cartCfg.labels);
  let lastFocus = null;

  const updateCount = (count) => {
    $$('[data-cari-cart-count]').forEach((el) => { el.textContent = count; el.hidden = !count; });
  };

  const renderCart = (cart) => {
    if (!drawer) return;
    updateCount(cart.item_count);
    const lines = $('[data-cari-lines]', drawer);
    const empty = !cart.items.length;
    $('[data-cari-empty]', drawer).hidden = !empty;
    $('[data-cari-foot]', drawer).hidden = empty;

    lines.innerHTML = cart.items.map((item) => {
      const img = item.image ? item.image + (item.image.includes('?') ? '&' : '?') + 'width=160' : '';
      const plan = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan;
      const compare = item.original_line_price > item.final_line_price ? `<s>${CARI.money(item.original_line_price)}</s>` : '';
      return `<li class="cari-line" data-key="${esc(item.key)}">
        ${img ? `<img class="cari-line__img" src="${esc(img)}" alt="" width="72" height="88" loading="lazy">` : '<span class="cari-line__img"></span>'}
        <div>
          <a class="cari-line__title" href="${esc(item.url)}">${esc(item.product_title)}</a>
          ${item.variant_title ? `<p class="cari-line__meta">${esc(relabel(item.variant_title, cartLabels))}</p>` : ''}
          ${plan ? `<p class="cari-line__plan">${esc(plan.name)}</p>` : ''}
          <div class="cari-qty">
            <button type="button" data-qty="${item.quantity - 1}" aria-label="Decrease quantity">−</button>
            <span>${item.quantity}</span>
            <button type="button" data-qty="${item.quantity + 1}" aria-label="Increase quantity">+</button>
          </div>
          <div><button type="button" class="cari-line__remove" data-qty="0">Remove</button></div>
        </div>
        <p class="cari-line__price">${compare}${CARI.money(item.final_line_price)}</p>
      </li>`;
    }).join('');

    const subtotal = $('[data-cari-subtotal]', drawer);
    if (subtotal) subtotal.textContent = CARI.money(cart.total_price);

    // Progress: buy-2-get-1 nudge takes priority, else free shipping bar
    const prog = $('[data-cari-progress]', drawer);
    const progText = $('[data-cari-progress-text]', drawer);
    const progBar = $('[data-cari-progress-bar]', drawer);
    prog.hidden = true;
    if (!empty && cartCfg.offer) {
      const every = cartCfg.offerEvery || 3;
      const bags = cart.items.reduce((n, i) => n + i.quantity, 0);
      const rem = bags % every === 0 ? 0 : every - (bags % every);
      prog.hidden = false;
      progText.textContent = rem === 0 ? cartCfg.offerDone : (cartCfg.offerText || '').replace('[n]', rem).replace(/bag\b/, rem > 1 ? 'bags' : 'bag');
      progBar.style.width = `${Math.round(((every - rem) / every) * 100)}%`;
    } else if (!empty && cartCfg.freeShipping > 0) {
      const left = cartCfg.freeShipping - cart.total_price;
      prog.hidden = false;
      progText.textContent = left > 0 ? `You're ${CARI.money(left)} away from free shipping` : 'You’ve unlocked free shipping';
      progBar.style.width = `${Math.min(100, Math.round((cart.total_price / cartCfg.freeShipping) * 100))}%`;
    }

    // Upsell: products not already in the cart
    const up = $('[data-cari-upsell]', drawer);
    if (up) {
      const inCart = new Set(cart.items.map((i) => i.product_id));
      const picks = (cartCfg.upsell || []).filter((u) => !inCart.has(u.productId)).slice(0, 3);
      up.hidden = empty || !picks.length;
      $('[data-cari-upsell-list]', up).innerHTML = picks.map((u) => `
        <div class="cari-upsell__item">
          ${u.image ? `<img src="${esc(u.image)}" alt="" width="56" height="64" loading="lazy">` : '<span></span>'}
          <div><a class="cari-upsell__title" href="${esc(u.url)}">${esc(u.title)}</a><p class="cari-upsell__meta">${esc(relabel(u.variant, cartLabels))} · ${CARI.money(u.price)}</p></div>
          <button type="button" class="cari-btn cari-btn--ghost cari-upsell__add" data-upsell-add="${u.variantId}">Add</button>
        </div>`).join('');
    }
  };

  const fetchCart = () => fetch(url('/cart.js'), { headers: { Accept: 'application/json' } }).then((r) => r.json());

  CARI.cart = {
    open() {
      if (!drawer) { window.location.href = url('/cart'); return; }
      lastFocus = document.activeElement;
      drawer.hidden = false;
      document.body.classList.add('cari-locked');
      requestAnimationFrame(() => drawer.classList.add('is-open'));
      fetchCart().then(renderCart);
      setTimeout(() => { const c = $('[data-cari-cart-close].cari-iconbtn', drawer); c && c.focus(); }, 50);
    },
    close() {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      document.body.classList.remove('cari-locked');
      setTimeout(() => { drawer.hidden = true; }, 350);
      lastFocus && lastFocus.focus && lastFocus.focus();
    },
    isOpen: () => drawer && !drawer.hidden,
    refresh: () => fetchCart().then(renderCart),
  };

  // Every cart write goes through one queue so requests reach Shopify in order,
  // and checkout can wait for the last one to land before leaving the page.
  let cartQueue = Promise.resolve();
  const enqueue = (task) => {
    const run = cartQueue.then(task, task);
    cartQueue = run.catch(() => {});
    return run;
  };

  const postJSON = (path, body) => fetch(url(path), {
    method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(body),
  }).then(async (r) => {
    const data = await r.json();
    if (!r.ok) throw new Error(data.description || data.message || 'Cart update failed');
    return data;
  });

  const change = (key, quantity) => {
    drawer.classList.add('is-busy');
    return enqueue(() => postJSON('/cart/change.js', { id: key, quantity }))
      .then(renderCart)
      // On failure, re-read the real cart so the drawer never shows stale lines
      .catch(() => fetchCart().then(renderCart))
      .finally(() => drawer.classList.remove('is-busy'));
  };

  CARI.addToCart = (items) => enqueue(() => postJSON('/cart/add.js', { items })).then((data) => {
    if (window.klaviyo && data.items && data.items[0]) {
      const i = data.items[0];
      window.klaviyo.push(['track', 'Added to Cart', { ProductName: i.product_title, ProductID: i.product_id, VariantID: i.variant_id, Price: i.final_price / 100, URL: location.origin + i.url }]);
    }
    return data;
  });

  // Checkout: wait for queued cart writes, confirm the cart server-side, clear cached UI state, then go.
  const checkoutForm = drawer && $('[data-cari-foot] form', drawer);
  if (checkoutForm) {
    checkoutForm.addEventListener('submit', (e) => {
      e.preventDefault();
      const btn = $('button[name="checkout"]', checkoutForm);
      btn.setAttribute('aria-busy', 'true');
      btn.disabled = true;
      cartQueue
        .then(fetchCart)
        .then((cart) => {
          if (!cart.item_count) { renderCart(cart); return; }
          try { localStorage.removeItem('__ui'); } catch (err) {}
          window.location.href = url('/checkout');
        })
        .catch(() => {
          // Couldn't confirm the cart; still hand off, Shopify reads the cart server-side
          try { localStorage.removeItem('__ui'); } catch (err) {}
          window.location.href = url('/checkout');
        })
        .finally(() => { btn.removeAttribute('aria-busy'); btn.disabled = false; });
    });
  }

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-cari-cart-open]');
    if (opener && drawer) { e.preventDefault(); CARI.cart.open(); return; }
    if (e.target.closest('[data-cari-cart-close]')) { CARI.cart.close(); return; }
    const qty = e.target.closest('.cari-line [data-qty]');
    if (qty) { change(qty.closest('.cari-line').dataset.key, Number(qty.dataset.qty)); return; }
    const add = e.target.closest('[data-upsell-add]');
    if (add) {
      add.setAttribute('aria-busy', 'true');
      CARI.addToCart([{ id: Number(add.dataset.upsellAdd), quantity: 1 }]).then(CARI.cart.refresh).catch(() => {}).finally(() => add.removeAttribute('aria-busy'));
    }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && CARI.cart.isOpen()) CARI.cart.close(); });

  /* ---------------- Buy box ---------------- */
  $$('[data-cari-buybox]').forEach((box) => {
    const data = readJSON($('[data-cari-product-json]', box));
    if (!data) return;
    const form = $('form.cari-form', box);
    const variantInput = $('[data-cari-variant-input]', box);
    const planInput = $('[data-cari-plan-input]', box);
    const atc = $('[data-cari-atc]', box);
    const atcLabel = $('[data-cari-atc-label]', box);
    const errorEl = $('[data-cari-error]', box);
    const subCard = $('[data-cari-sub-card]', box);
    const cadence = $('[data-cari-cadence]', box);
    const sticky = $('[data-cari-sticky]', box);
    const labels = parseLabels(data.labels);

    // Preview membership UI on unpublished themes before selling plans exist
    let preview = false;
    if (!data.plans.length && data.previewSub && isPreviewTheme() && subCard) {
      preview = true;
      subCard.hidden = false;
      cadence.innerHTML = ['Delivered monthly', 'Delivered every 3 months'].map((n, i) =>
        `<label class="cari-pill cari-pill--sm"><input type="radio" name="cari-plan-preview" value="preview-${i}" data-cari-plan ${i === 0 ? 'checked' : ''}><span>${n}</span></label>`).join('');
      const subRadio = $('[data-cari-mode][value="sub"]', box);
      subRadio && (subRadio.checked = true);
    }

    const selectedOptions = () => {
      const opts = [];
      $$('[data-cari-option]:checked', box).forEach((i) => { opts[Number(i.dataset.cariOption)] = i.value; });
      return opts;
    };
    const findVariant = (opts) => data.variants.find((v) => v.options.every((o, i) => opts[i] === undefined || opts[i] === o));
    const mode = () => { const m = $('[data-cari-mode]:checked', box); return m ? m.value : 'once'; };
    const planId = () => { const p = $('[data-cari-plan]:checked', box); return p ? p.value : ''; };

    const ozFromOptions = (opts) => {
      for (const o of opts) {
        const m = /([\d.]+)\s*(oz|lb)/i.exec(o || '');
        if (m) return parseFloat(m[1]) * (m[2].toLowerCase() === 'lb' ? 16 : 1);
      }
      return 0;
    };

    const update = (pushUrl) => {
      const opts = selectedOptions();
      const v = findVariant(opts);
      const m = mode();
      const pid = planId();
      errorEl.hidden = true;

      if (!v) {
        atc.disabled = true; atcLabel.textContent = 'Unavailable';
        return;
      }
      variantInput.value = v.id;
      // Preview pricing mirrors the planned plans: 12oz has its own member price, larger sizes are $10 off one-time
      const subPrice = preview ? (ozFromOptions(v.options) === 12 ? data.previewSubPrice : v.price - PREVIEW_OFF_CENTS) : v.plans[pid];
      planInput.value = m === 'sub' && !preview ? pid : '';

      $('[data-cari-once-price]', box).textContent = CARI.money(v.price);
      const subEl = $('[data-cari-sub-price]', box);
      const cmpEl = $('[data-cari-sub-compare]', box);
      const saveEl = $('[data-cari-save]', box);
      if (subEl && subPrice != null) {
        subEl.textContent = CARI.money(subPrice);
        const saves = subPrice < v.price;
        cmpEl.textContent = saves ? CARI.money(v.price) : '';
        saveEl.hidden = !saves;
        if (saves) saveEl.textContent = `Save ${Math.round((1 - subPrice / v.price) * 100)}%`;
      }

      // Price per cup (memberships only)
      const cppEl = $('[data-cari-cpp]', box);
      const oz = ozFromOptions(v.options);
      if (cppEl) cppEl.textContent = data.cupsPerOz > 0 && oz && subPrice ? `≈ ${CARI.money(Math.round(subPrice / (oz * data.cupsPerOz)))} per cup` : '';

      const price = m === 'sub' && subPrice != null ? subPrice : v.price;
      const blocked = m === 'sub' && preview;
      atc.disabled = !v.available || blocked;
      atcLabel.textContent = !v.available ? 'Sold out' : blocked ? 'Preview: subscriptions not set up yet' : `${m === 'sub' ? atc.dataset.labelSub : atc.dataset.labelOnce} · ${CARI.money(price)}`;

      if (sticky) {
        const planName = m === 'sub' ? ($('[data-cari-plan]:checked + span', box) || {}).textContent || '' : 'One-time';
        $('[data-cari-sticky-meta]', sticky).textContent = [...v.options.filter((o) => !/^default title$/i.test(o)).map((o) => labels[o] || o), planName].filter(Boolean).join(' · ');
        $('[data-cari-sticky-price]', sticky).textContent = CARI.money(price);
        $('[data-cari-sticky-label]', sticky).textContent = m === 'sub' ? 'Subscribe' : 'Add';
        $('[data-cari-sticky-atc]', sticky).disabled = atc.disabled;
      }

      if (pushUrl) {
        const u = new URL(location.href);
        u.searchParams.set('variant', v.id);
        history.replaceState(history.state, '', u.toString());
      }
    };

    box.addEventListener('change', (e) => {
      if (e.target.matches('[data-cari-option], [data-cari-mode], [data-cari-plan]')) update(e.target.matches('[data-cari-option]'));
    });

    form.addEventListener('submit', (e) => {
      e.preventDefault();
      if (atc.disabled) return;
      atc.setAttribute('aria-busy', 'true');
      const item = { id: Number(variantInput.value), quantity: 1 };
      if (planInput.value) item.selling_plan = Number(planInput.value);
      CARI.addToCart([item])
        .then(() => CARI.cart.open())
        .catch((err) => { errorEl.textContent = err.message; errorEl.hidden = false; })
        .finally(() => atc.removeAttribute('aria-busy'));
    });

    // Gallery dots
    const track = $('[data-cari-track]', box);
    const dots = $('[data-cari-dots]', box);
    if (track && dots && track.children.length > 1) {
      dots.innerHTML = Array.from(track.children).map(() => '<span></span>').join('');
      const setDot = () => {
        const i = Math.round(track.scrollLeft / track.clientWidth);
        $$('span', dots).forEach((d, j) => d.classList.toggle('is-active', i === j));
      };
      track.addEventListener('scroll', () => requestAnimationFrame(setDot), { passive: true });
      setDot();
    }

    // Sticky ATC: visible whenever the main button is off-screen
    if (sticky && 'IntersectionObserver' in window) {
      const stickyBtn = $('[data-cari-sticky-atc]', sticky);
      stickyBtn.addEventListener('click', () => form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true })));
      const footer = $('.cari-footer');
      let atcVisible = true; let footerVisible = false;
      const sync = () => {
        const show = !atcVisible && !footerVisible;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', String(!show));
        stickyBtn.tabIndex = show ? 0 : -1;
      };
      new IntersectionObserver(([en]) => { atcVisible = en.isIntersecting; sync(); }).observe(atc);
      if (footer) new IntersectionObserver(([en]) => { footerVisible = en.isIntersecting; sync(); }).observe(footer);
    }

    update(false);
  });

  /* ---------------- Exit-intent popup ---------------- */
  const exitEl = $('[data-cari-exit]');
  if (exitEl) {
    const SEEN = 'cari_exit_seen';
    const DONE = 'cari_exit_done';
    const days = Number(exitEl.dataset.days || 7);
    const minMs = Number(exitEl.dataset.delay || 8) * 1000;
    const start = Date.now();
    let shown = false;

    const open = () => {
      exitEl.hidden = false;
      document.body.classList.add('cari-locked');
      requestAnimationFrame(() => exitEl.classList.add('is-open'));
      const f = $('input[type=email], [data-cari-exit-close].cari-btn', exitEl);
      setTimeout(() => f && f.focus(), 60);
    };
    const close = () => {
      exitEl.classList.remove('is-open');
      document.body.classList.remove('cari-locked');
      setTimeout(() => { exitEl.hidden = true; }, 300);
    };
    exitEl.addEventListener('click', (e) => { if (e.target.closest('[data-cari-exit-close]')) close(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !exitEl.hidden) close(); });

    if (exitEl.hasAttribute('data-success')) {
      // Returned from a successful signup: show the code (this is the only non-exit trigger)
      store.set(DONE, '1');
      open();
    } else if (exitEl.hasAttribute('data-error')) {
      open();
    } else {
      const seenAt = Number(store.get(SEEN) || 0);
      const suppressed = store.get(DONE) || (seenAt && Date.now() - seenAt < days * 864e5);
      if (!suppressed) {
        const trigger = () => {
          if (shown || Date.now() - start < minMs || CARI.cart.isOpen()) return;
          shown = true;
          store.set(SEEN, String(Date.now()));
          open();
        };
        // Desktop: cursor leaves through the top of the viewport
        document.addEventListener('mouseout', (e) => { if (!e.relatedTarget && e.clientY <= 0) trigger(); });
        // Touch: a fast scroll back up after reading a good chunk of the page
        if (matchMedia('(pointer: coarse)').matches) {
          let maxY = 0; let lastY = scrollY; let lastT = performance.now();
          addEventListener('scroll', () => {
            const y = scrollY; const t = performance.now();
            maxY = Math.max(maxY, y);
            const velocity = (lastY - y) / Math.max(1, t - lastT); // px/ms, positive = upward
            const readEnough = maxY > document.documentElement.scrollHeight * 0.3;
            if (readEnough && velocity > 1.5 && y < maxY - innerHeight * 0.5) trigger();
            lastY = y; lastT = t;
          }, { passive: true });
        }
      }
    }
  }
})();
